import { Input } from "@/components/ui/input";
import { cn } from "@/utils/cn";
import type { InputHTMLAttributes } from "react";

export default function CustomInput({
  className,
  ...props
}: InputHTMLAttributes<HTMLInputElement>) {
  return (
    <Input
      className={cn(
        "border bg-white border-gray-200  py-2 px-3 text-gray-800   w-full rounded-full p-5",
        className
      )}
      {...props}
    />
  );
}
